export const JourneyStepper = ({ steps, step, maxStep, resultsReady, onGo }) => (
  <ol className="flex gap-2 overflow-x-auto" aria-label="Journey progress">
    {steps.map((label, index) => {
      const enabled = index <= maxStep || (resultsReady && index < steps.length);
      return (
        <li key={label}>
          <button type="button" onClick={() => enabled && onGo(index)} disabled={!enabled} data-testid={`journey-step-link-${index}`}
            className={`flex min-w-max items-center gap-2 rounded-full px-3 py-2 text-xs font-bold transition-colors ${index === step ? "bg-cobalt text-white" : index < step || resultsReady ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100" : "bg-surface text-slatey"} ${!enabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white/20">{index + 1}</span>{label}
          </button>
        </li>
      );
    })}
  </ol>
);
